import { ChevronDown, CircleHelp } from "lucide-react";
import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  question: string;
  answer: React.ReactNode;
  className?: string;
  collapsible?: boolean;
};

const FAQItem: React.FC<Props> = ({
  answer,
  question,
  className,
  collapsible = false,
}) => {
  if (collapsible) {
    return (
      <details className={twMerge("group px-5", className)}>
        <summary className="flex cursor-pointer list-none flex-row items-center gap-3 py-4 [&::-webkit-details-marker]:hidden">
          <div className="flex size-8 min-w-8 items-center justify-center rounded-full bg-primary">
            <CircleHelp className="size-5 text-secondary" />
          </div>
          <span className="flex-1 text-popover-foreground font-medium">
            {question}
          </span>
          <ChevronDown className="size-5 min-w-5 text-muted-foreground transition-transform group-open:rotate-180" />
        </summary>
        <div className="pb-5 pl-11 pr-8">
          <p className="text-muted-foreground text-sm md:text-base">{answer}</p>
        </div>
      </details>
    );
  }

  return (
    <div className={twMerge("flex flex-row gap-3 px-5 py-4", className)}>
      <div className="size-9 min-w-9 rounded-full bg-primary flex items-center justify-center">
        <CircleHelp className="size-6 text-secondary" />
      </div>
      <div className="space-y-1">
        <p className="text-popover-foreground font-medium">{question}</p>
        <p className="text-muted-foreground text-sm md:text-base">{answer}</p>
      </div>
    </div>
  );
};

export default FAQItem;
